import { HPCLearningOutcome } from './hpc_learning_outcome';

export class HPCSection {
  constructor({
    id = null,
    title = null,
    objective,
    learningOutcomes = [],
    aiSummary = null
  }) {
    this.id = id;
    this.title = title;
    this.objective = objective;
    this.learningOutcomes = learningOutcomes;
    this.aiSummary = aiSummary;
  }

  static fromJSON(json) {
    return new HPCSection({
      id: json.id,
      title: json.title,
      objective: json.objective || '',
      aiSummary: json.aiSummary,
      learningOutcomes: (json.learningOutcomes || []).map(outcome => 
        HPCLearningOutcome.fromJSON(outcome)
      )
    });
  }

  addLearningOutcome(outcome) {
    this.learningOutcomes.push(outcome);
  }

  removeLearningOutcome(outcome) {
    const index = this.learningOutcomes.findIndex(item => item.id === outcome.id);
    if (index !== -1) {
      this.learningOutcomes.splice(index, 1);
    }
  }

  updateLearningOutcome(outcome) {
    try {
      const index = this.learningOutcomes.findIndex(item => item.id === outcome.id);
      if (index !== -1) {
        this.learningOutcomes[index] = outcome;
      }
    } catch (e) {
      console.error(e);
    }
  }

  toJSON() {
    return {
      id: this.id,
      title: this.title,
      objective: this.objective,
      aiSummary: this.aiSummary,
      learningOutcomes: this.learningOutcomes.map(outcome => outcome.toJSON())
    };
  }
}